import React, { useState, useCallback } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Alert, Button, Modal } from "components/bootstrap";
import { ModalSubmit } from "components/common";
import Agree from "./Agree";
import KinesisSetupSteps from "./KinesisSetupSteps";
const DocsAnchor = ({ href, children }) => /* @__PURE__ */ React.createElement("a", { href, target: "_blank", rel: "noopener noreferrer" }, children);
const SetupModal = ({ onSubmit, onCancel, groupName, streamName }) => {
  const { t } = useTranslation("integrations");
  const [agreed, setAgreed] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const buttonOtherText = !error && !success ? t("aws_kinesis_setup_modal.creating_button") : t("aws_kinesis_setup_modal.close_button");
  const buttonText = success ? t("aws_kinesis_setup_modal.continue_button") : buttonOtherText;
  const handleSuccess = () => {
    setSuccess(true);
    setError(false);
  };
  const handleError = useCallback(() => {
    setSuccess(false);
    setError(true);
  }, []);
  return /* @__PURE__ */ React.createElement(Modal, { show: true, onHide: () => {
  } }, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, agreed ? t("aws_kinesis_setup_modal.executing_title") : t("aws_kinesis_setup_modal.agreement_title"))), /* @__PURE__ */ React.createElement(Modal.Body, null, agreed ? /* @__PURE__ */ React.createElement(KinesisSetupSteps, { onSuccess: handleSuccess, onError: handleError }) : /* @__PURE__ */ React.createElement(Agree, { groupName, streamName }), agreed && success && /* @__PURE__ */ React.createElement(Alert, { key: "delayedLogs", bsStyle: "warning" }, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "aws_kinesis_setup_modal.delayed_logs",
      components: {
        cloudWatchLink: /* @__PURE__ */ React.createElement(DocsAnchor, { href: "https://docs.aws.amazon.com/AmazonCloudWatch/latest/logs/Subscriptions.html" })
      }
    }
  ))), /* @__PURE__ */ React.createElement(Modal.Footer, null, agreed ? /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", onClick: success ? onSubmit : onCancel, type: "button", disabled: !error && !success }, buttonText) : /* @__PURE__ */ React.createElement(
    ModalSubmit,
    {
      submitButtonText: t("aws_kinesis_setup_modal.agree_button"),
      onSubmit: () => setAgreed(true),
      submitButtonType: "button",
      onCancel
    }
  )));
};
export default SetupModal;
